import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
/**
 * @ingore
 */
@Injectable({ providedIn: 'root' })
export class LanguageService {

  INIT_VALUE = null;

  private Language$ = new BehaviorSubject<string>(this.initializeLanguage());
  public Language = this.Language$.asObservable().pipe(distinctUntilChanged());

  constructor(private http: HttpClient, private router: Router) { }

  /**
   * Initializes language
   * @returns  
   */
  initializeLanguage() {
    let language = getNavigatorLanguage();

    const lang = JSON.parse((localStorage.getItem('panelLang')));

    return lang ? lang.language : language;
  }

  public setLanguage(language: string) {
    this.Language$.next(language);
  }

  public get currentLanguage(): any {
    return this.Language$.value;
  }

  removeLanguage(): void {
    localStorage.removeItem('panelLang');
    this.Language$.next(null);
  }

}

/**
 * @ingore
 */
const getNavigatorLanguage = () => {
  let lang = '';
  if (navigator.languages && navigator.languages.length) {
    lang = navigator.languages[0];
  } else {
    lang = navigator.language || 'en';
  }

  if (lang.indexOf('-') !== -1) {
    lang = lang.split('-')[0];
  }

  let languages = Object.keys(Languages).map(key => Languages[key]);
  !languages.includes(lang) ? lang = 'en' : null;

  return lang;
}
/**
 * @ingore
 */
export enum Languages {
  EN = 'en',
  DE = 'de',
  PT = 'pt'
}

export const defaultLanguages = [
  {
    name: 'en',
    label: 'english',
  },
  {
    name: 'de',
    label: 'german',
  },
  {
    name: 'fr',
    label: 'french',
  },
  {
    name: 'es',
    label: 'spanish',
  },
  {
    name: 'pt',
    label: 'portuguese',
  },
  {
    name: 'ca',
    label: 'catalan',
  },
  {
    name: 'it',
    label: 'italian',
  },
  {
    name: 'hu',
    label: 'hungarian'
  }
];